var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesTools1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_15058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7894 72C54.1514 72 68.2263 55.8824 68.2263 36C68.2263 16.1176 54.1514 0 36.7894 0C19.4225 0 5.34766 16.1176 5.34766 36C5.34766 55.8824 19.4225 72 36.7894 72Z",
    fill: "#EAEEF9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_228_15058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8944 67.9051H2.28539C1.03194 67.9051 0 66.722 0 65.2854V33.8462C0 32.4097 1.03194 31.2266 2.28539 31.2266H48.8944C50.1529 31.2266 51.1848 32.4097 51.1848 33.8462V65.2854C51.1848 66.722 50.1529 67.9051 48.8944 67.9051Z",
    fill: "url(#paint0_linear_228_15058)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.7942 47.0353L12.7539 42.8789C16.8112 43.2003 20.0027 47.0486 20.0933 51.6433C20.1336 54.5884 18.7896 57.1919 16.7307 58.6711L14.8631 54.8977C15.7743 54.1437 16.328 52.914 16.3431 51.4457C16.328 49.2823 14.7322 47.3579 12.7942 47.0353Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9634 42.9805L12.0036 47.1023C10.8307 47.217 9.77358 47.9456 9.15944 49.0711L6.05859 46.7193C7.28687 44.5535 9.39607 43.0957 11.9634 42.9805Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39503 47.8125L8.57146 50.1695C8.46575 50.5848 8.36 51.0001 8.4053 51.5191C8.40027 53.9164 10.2075 55.9347 12.4425 56.0366C13.0667 56.0268 13.6154 55.9226 14.0936 55.7239L15.9411 59.3751C14.899 59.9327 13.7161 60.2167 12.4828 60.1516C8.2291 60.0606 4.77082 56.1276 4.69531 51.4085C4.70035 50.1251 4.93695 48.87 5.39503 47.8125Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5015 37.2268H4.4967C3.94297 37.2268 3.5 36.72 3.5 36.0858C3.5 35.4522 3.94297 34.9453 4.4967 34.9453H24.5367C25.0905 34.9453 25.5334 35.4522 25.5334 36.0858C25.5334 36.72 25.0552 37.2268 24.5015 37.2268Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_228_15058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7069 40.4793H23.0979C21.8445 40.4793 20.8125 39.2962 20.8125 37.8597V6.42045C20.8125 4.9839 21.8445 3.80078 23.0979 3.80078H69.7069C70.9603 3.80078 71.9973 4.9839 71.9973 6.42045V37.8597C71.9973 39.2962 70.9603 40.4793 69.7069 40.4793Z",
    fill: "url(#paint1_linear_228_15058)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.3129 9.79772H25.3131C24.7594 9.79772 24.3164 9.29087 24.3164 8.65669C24.3164 8.02309 24.7594 7.51562 25.3131 7.51562H45.3531C45.9069 7.51562 46.3499 8.02309 46.3499 8.65669C46.3499 9.29087 45.8666 9.79772 45.3129 9.79772Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5433 36.2561H31.5498C31.2528 36.2561 30.9961 35.96 30.9961 35.6219C30.9961 35.2844 31.2528 34.9883 31.5498 34.9883H33.5433C33.8403 34.9883 34.097 35.2844 34.097 35.6219C34.1322 35.96 33.8755 36.2561 33.5433 36.2561Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.805 36.2561H42.8115C42.5145 36.2561 42.2578 35.96 42.2578 35.6219C42.2578 35.2844 42.5145 34.9883 42.8115 34.9883H44.805C45.097 34.9883 45.3587 35.2844 45.3587 35.6219C45.3587 35.96 45.097 36.2561 44.805 36.2561Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5739 54.437H32.7009C32.4441 54.437 32.2227 54.1835 32.2227 53.8881V53.8034C32.2227 53.5073 32.4441 53.2539 32.7009 53.2539H40.5739C40.8357 53.2539 41.0571 53.5073 41.0571 53.8034V53.8881C41.0571 54.1835 40.8357 54.437 40.5739 54.437Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9344 49.2222H32.7009C32.4441 49.2222 32.2227 48.9687 32.2227 48.6732V48.5886C32.2227 48.2925 32.4441 48.0391 32.7009 48.0391H36.9344C37.1911 48.0391 37.4126 48.2925 37.4126 48.5886V48.6732C37.4126 48.9687 37.1911 49.2222 36.9344 49.2222Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0033 59.5073H32.7009C32.4441 59.5073 32.2227 59.2539 32.2227 58.9578V58.8731C32.2227 58.5777 32.4441 58.3242 32.7009 58.3242H39.0033C39.2601 58.3242 39.4815 58.5777 39.4815 58.8731V58.9578C39.5168 59.2539 39.2953 59.5073 39.0033 59.5073Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.055 36.2561H54.0616C53.7646 36.2561 53.5078 35.96 53.5078 35.6219C53.5078 35.2844 53.7646 34.9883 54.0616 34.9883H56.055C56.347 34.9883 56.6087 35.2844 56.6087 35.6219C56.644 35.96 56.3872 36.2561 56.055 36.2561Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.426 36.2561H65.4326C65.1356 36.2561 64.8789 35.96 64.8789 35.6219C64.8789 35.2844 65.1356 34.9883 65.4326 34.9883H67.426C67.718 34.9883 67.9798 35.2844 67.9798 35.6219C67.9798 35.96 67.7583 36.2561 67.426 36.2561Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6786 30.9318H25.0577C24.7607 30.9318 24.5039 30.6363 24.5039 30.2982C24.5039 29.9601 24.7607 29.6641 25.0577 29.6641H26.6786C26.9756 29.6641 27.2323 29.9601 27.2323 30.2982C27.2323 30.6784 26.9756 30.9318 26.6786 30.9318Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6786 23.3615H25.0577C24.7607 23.3615 24.5039 23.066 24.5039 22.7279C24.5039 22.3898 24.7607 22.0938 25.0577 22.0938H26.6786C26.9756 22.0938 27.2323 22.3898 27.2323 22.7279C27.2323 23.066 26.9756 23.3615 26.6786 23.3615Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6786 15.799H25.0577C24.7607 15.799 24.5039 15.5029 24.5039 15.1648C24.5039 14.8267 24.7607 14.5312 25.0577 14.5312H26.6786C26.9756 14.5312 27.2323 14.8267 27.2323 15.1648C27.2323 15.5029 26.9756 15.799 26.6786 15.799Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.527 29.7891H29.8867V30.2119H68.527V29.7891Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6267 22.1797H29.8867V22.6025H30.6267V22.1797Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2756 22.6025H64.8007V22.1797H66.2756V22.6025ZM63.3257 22.6025H61.8508V22.1797H63.3257V22.6025ZM60.3356 22.6025H58.8607V22.1797H60.3356V22.6025ZM57.3858 22.6025H55.9058V22.1797H57.3858V22.6025ZM54.3956 22.6025H52.9207V22.1797H54.3956V22.6025ZM51.4407 22.6025H49.9658V22.1797H51.4407V22.6025ZM48.4506 22.6025H46.9756V22.1797H48.4506V22.6025ZM45.5007 22.6025H44.0257V22.1797H45.5007V22.6025ZM42.5105 22.6025H41.0356V22.1797H42.5105V22.6025ZM39.5607 22.6025H38.0807V22.1797H39.5607V22.6025ZM36.5705 22.6025H35.0956V22.1797H36.5705V22.6025ZM33.5804 22.6025H32.1055V22.1797H33.5804V22.6025Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.533 22.1797H67.793V22.6025H68.533V22.1797Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6267 14.5742H29.8867V14.997H30.6267V14.5742Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2756 14.997H64.8007V14.5742H66.2756V14.997ZM63.3257 14.997H61.8508V14.5742H63.3257V14.997ZM60.3356 14.997H58.8607V14.5742H60.3356V14.997ZM57.3858 14.997H55.9058V14.5742H57.3858V14.997ZM54.3956 14.997H52.9207V14.5742H54.3956V14.997ZM51.4407 14.997H49.9658V14.5742H51.4407V14.997ZM48.4506 14.997H46.9756V14.5742H48.4506V14.997ZM45.5007 14.997H44.0257V14.5742H45.5007V14.997ZM42.5105 14.997H41.0356V14.5742H42.5105V14.997ZM39.5607 14.997H38.0807V14.5742H39.5607V14.997ZM36.5705 14.997H35.0956V14.5742H36.5705V14.997ZM33.5804 14.997H32.1055V14.5742H33.5804V14.997Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.533 14.5742H67.793V14.997H68.533V14.5742Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2577 55.1133H28.261C27.8935 55.1133 27.6367 54.7752 27.6367 54.3945V53.2534C27.6367 52.8312 27.9338 52.5352 28.261 52.5352H29.2577C29.6302 52.5352 29.8869 52.8733 29.8869 53.2534V54.3945C29.8869 54.8172 29.5899 55.1133 29.2577 55.1133Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2577 49.8985H28.261C27.8935 49.8985 27.6367 49.5604 27.6367 49.1797V48.0386C27.6367 47.6164 27.9338 47.3203 28.261 47.3203H29.2577C29.6302 47.3203 29.8869 47.6584 29.8869 48.0386V49.1797C29.8869 49.6024 29.5899 49.8985 29.2577 49.8985Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2577 60.1837H28.261C27.8935 60.1837 27.6367 59.8455 27.6367 59.4654V58.3243C27.6367 57.9015 27.9338 57.6055 28.261 57.6055H29.2577C29.6302 57.6055 29.8869 57.9436 29.8869 58.3243V59.4654C29.8869 59.8876 29.5899 60.1837 29.2577 60.1837Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6882 21.7188H31.4733C30.9196 21.7188 30.4766 22.2262 30.4766 22.8598V29.7896H34.6849V22.8598C34.6849 22.2262 34.2419 21.7188 33.6882 21.7188Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.907 18.207H42.692C42.1383 18.207 41.6953 18.7145 41.6953 19.3481V29.7432H45.9389V19.3481C45.9037 18.7145 45.4607 18.207 44.907 18.207Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1999 26.4492H53.985C53.4313 26.4492 52.9883 26.9561 52.9883 27.5903V29.7457H57.1966V27.5903C57.1966 26.9561 56.7537 26.4492 56.1999 26.4492Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5358 15.7578H65.3209C64.7672 15.7578 64.3242 16.2653 64.3242 16.8989V29.7869H68.5678V16.8989C68.5325 16.2653 68.0895 15.7578 67.5358 15.7578Z",
    fill: "#7D63EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_228_15058",
    x: -8,
    y: 27.2266,
    width: 67.1836,
    height: 52.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_15058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_15058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_228_15058",
    x: 10.8125,
    y: -2.19922,
    width: 71.1836,
    height: 56.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_15058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_15058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_15058",
    x1: 25.5773,
    y1: 30.3781,
    x2: 25.5773,
    y2: 68.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_15058",
    x1: 46.3848,
    y1: 2.95233,
    x2: 46.3848,
    y2: 40.8745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F2F8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_15058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTools1);
export default __webpack_public_path__ + "static/media/sales-tools-1.9ef6cca509f9101502b25d231dd645da.svg";
export { ForwardRef as ReactComponent };